import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { createI18n } from 'vue-i18n';
import enUS from "./i18n/en_US.json"
import esES from "./i18n/es_ES.json"
import { connectAuthEmulator } from "firebase/auth"
import { connectFirestoreEmulator } from "firebase/firestore"
import { connectFunctionsEmulator, } from "firebase/functions"
// import { connectStorageEmulator } from "firebase/storage"
import addMocks from "./mocks/add_mocks"
import { auth, db, funcs } from "./firebase/config"

// If we are in dev env we use the emulators.
console.log('The NODE_ENV: ', process.env.NODE_ENV.trim())
if (process.env.NODE_ENV.trim() === 'development') {
    console.log('We are in the development environment.')

    connectFunctionsEmulator(funcs, '127.0.0.1', 5001)
    console.log('functions emulator is running.')
    connectAuthEmulator(auth, "http://127.0.0.1:9099")
    connectFirestoreEmulator(db, '127.0.0.1', 8080)
    // connectStorageEmulator(storage, "127.0.0.1", 9199)
    const mocks = addMocks()
    mocks.addMock()
}

// Add the localization.
const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en: { ...enUS },
        es: { ...esES },
    },
})

createApp(App).use(store).use(i18n).use(router).mount('#app')
